import React, { useEffect, useState } from "react";
import Container from "../../common/Container";
import Action from "../../common/Actions"
import "../../index.css";
import SearchIcon from "@mui/icons-material/Search";
import InputWithIcon from "../../common/InputWithIcon";
import { TH, TD, TR, Thead, Tbody } from "../../styled/table";
import Add from "@mui/icons-material/Add";
import Button from "../../common/Button";
import PaginationDiv from "../../common/PaginationDiv";
import CustomAddPage from "../../components/custom-pages/CustomAddModal"
import { createDocument, deleteDocumentById, getAllData } from "../../apis/customApiHandler";
import { convertToIndianTimezoneAndGetDate, handleDownClick, handleUpClick } from "../../utils/helpers";
import { LinearProgress } from "@mui/material";
import checkPermission from "../../utils/checkPermission";


function BodyTypes() {
  const [limit, setLimit] = useState(10);
  const [page, setPage] = React.useState(1);
  const [search, setSearch] = useState("")
  const [bodyTypes, setbodyTypes] = useState([])
  const [vehicleBodyType, setBodyType] = useState({})
  const [showEditModal, setShowEditModal] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const currentUser = JSON.parse(localStorage.getItem("user"))
  const [totalData, setTotalData] = useState(0);
  const [loading, setLoading] = useState(false)
  

  const getBodyType = async () => {
    setLoading(true)
    const data = await getAllData("/master/vehicle/getBodyType", {page, limit, search});
    setbodyTypes(data?.data)
    setTotalData(data?.totalData)
    setLoading(false)
  }
  useEffect(() => {
    getBodyType();
  }, [search, limit, page])

  const list = [
    {
      name: "Edit",
     condition: checkPermission([
    {
        permission: "masters",
        subPermission: ["UPDATE"]
    },
], currentUser),
      onClick: (BodyType) => {
        setBodyType(BodyType);
        setShowEditModal(true);
      },
      className: "text-grey",
    },
    {
      name: "Delete",
     condition: checkPermission([
    {
        permission: "masters",
        subPermission: ["DELETE"]
    },
], currentUser),
      onClick: async (BodyType) => {
        setBodyType(BodyType);
        await createDocument("/master/vehicle/updateBodyType?_id=" +  BodyType?._id, {deleted: true});
                await getBodyType()
      },
      className: "text-error",
    },
  ];
  return (
    <Container>
      <div className="flex flex-col md:flex-row justify-between">
        <div className="grid grid-col-1 col-span-2 md:col-span-1 flex flex-col">
          <div className="font-semibold text-[24px]"> Body Types</div>
        </div>

        <div className="flex flex-row text-secondary h-12 gap-3 text-xl">
          <div className="">
            <Button
              text="Add New Body Type"
              disabled = {!checkPermission([
                {
                    permission: "masters",
                    subPermission: ["CREATE"]
                },
            ], currentUser)}
              className="w-full flex flex-row border border-1 border-black items-center px-3 rounded-md h-12 text-[16px] font-medium text-white bg-dark-blue gap-3"
              Icon={<Add color="inherit" />}
              onClick={() => setShowAddModal(true)}
            />
          </div>
        </div>
      </div>
      <div className="mt-5">
        <InputWithIcon
          placeholder="Search for Body Type..."
          variant="outlined"
          setData={setSearch}
          Icon={<SearchIcon className="text-dark-grey" />}
          className="w-80 border border-gray-300 items-center px-2 rounded-md h-12 text-[16px] shadow-sm"
          inputClass="text-[16px]"
        />
      </div>
      <table className="w-full table">
        <Thead className="flex flex-row justify-between w-full">
          <tr className=" flex flex-row justify-between w-full">
            {/* <TH className="" type="checkbox"> <input type="checkbox"></input></TH> */}
            <TH handleUpClick= {handleUpClick} handleDownClick={handleDownClick} setData={setbodyTypes} field={"image"}> Image</TH>
            <TH handleUpClick= {handleUpClick} handleDownClick={handleDownClick} setData={setbodyTypes} field={"name"}>Body Type Name</TH>
            <TH handleUpClick= {handleUpClick} handleDownClick={handleDownClick} setData={setbodyTypes} field={"hoursBasedReading"}>Odometer Type</TH>
            <TH handleUpClick= {handleUpClick} handleDownClick={handleDownClick} setData={setbodyTypes} field={"createdAt"}>Created On</TH>
            <TH>Actions</TH>
          </tr>
        </Thead>
        {loading ? <LinearProgress color="secondary" /> :
          <Tbody className="flex flex-col justify-between w-full">
            {bodyTypes?.length ? bodyTypes?.map((entry, index) => {
              if (true)
                return (
                  <TR key={entry?._id} className="">
                    {/* <TD className="ml-2 text-center justify-center " type="checkbox"> <input type="checkbox"></input> </TD> */}
                    <TD> {entry.image && <img src= {entry.image} className="rounded-full h-10 w-10 mx-auto"/>} </TD>
                    <TD> {entry.name} </TD>
                    <TD> {entry.hoursBasedReading ? "Hours" : "Kilometer"} </TD>
                    <TD> {convertToIndianTimezoneAndGetDate(entry.createdAt)} </TD>
                    <TD className="text-center"> <Action list={list} data={entry} /> </TD>
                  </TR>
                );
            }): <div className= "w-full text-semibold text-center text-lightGrey p-3"> No Data Found </div>}
          </Tbody>
        }
      </table>
      <PaginationDiv
        page={page}
        setPage={setPage}
        length={totalData}
        limit={limit}
        setLimit={setLimit}
      />
      {showAddModal && <Create handleClick={async () => { setShowAddModal(false); await getBodyType() }} />}
      {showEditModal && <Create data={vehicleBodyType} handleClick={async () => { setShowEditModal(false); await getBodyType() }} />}
    </Container>
  )
}
function Create({ data, handleClick }) {
  const [initialValues, setInitialValues] = React.useState({
    name: data?.name || "",
    image: data?.image ? [data?.image]: null,
    hoursBasedReading: data?.hoursBasedReading,
  });
  const [tempData, setTempData] = useState({})

  const inputFields = [
    {
      name: "name",
      label: "BodyType Name",
      type: "text",
      required: true,
    },
    {
      name: "hoursBasedReading",
      label: "Hours Based Reading",
      type: "checkbox",
    },
    {
      name: "image",
      label: "Image",
      type: "file",
      required: true,
      className: "col-span-4 w-full",
      multiple: false,
      limit: 1,
      accept: "image/png, image/jpeg, image/jpg"

    },
  ];

  console.log({tempData})
  return (
    <CustomAddPage
      pageTitle={data ? "Update Body Type" : "Add Body Type"}
      url={data ? "/master/vehicle/updateBodyType" : "/master/vehicle/addBodyType"}
      action={!data ? "create" : "post"}
      updateId={data?._id}
      queryKey="vehicleBodyType"
      inputFields={inputFields}
      data={initialValues}
      setData={setTempData}
      handleClick={handleClick}
    />
  );
}
export default BodyTypes